import {createAction} from 'redux-actions'

export const runTests = createAction('RUN_TESTS')
